import { DeleteFilled, EditOutlined, EyeFilled } from "@ant-design/icons";
import { Button, Col, Pagination, Row, Space, Table, Card, List, Typography, Input, Select } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotFound from "../../../../components/common/notFound";
import ConfirmModal from "../../../../components/modal/confirmModal";
import FailModal from "../../../../components/modal/failModal";
import SuccessModal from "../../../../components/modal/successModal";
import Logo from "../../../../assets/images/ieat_logo.png";
import EmpIcon from "../../../../assets/images/dashbaord/user.png";
import EmpIcon_2 from "../../../../assets/images/dashbaord/user.png";
import EmpIcon_BUPA from "../../../../assets/images/dashbaord/emp/BUPA.png";
import EmpIcon_KUNPONG from "../../../../assets/images/dashbaord/emp/KUNPONG.png";
import EmpIcon_LINEE from "../../../../assets/images/dashbaord/emp/LINEE.png";
import EmpIcon_NIPA from "../../../../assets/images/dashbaord/emp/NIPA.png";
import EmpIcon_PATEEP from "../../../../assets/images/dashbaord/emp/PATEEP.png";
import EmpIcon_SUMET from "../../../../assets/images/dashbaord/emp/SUMET.png";
import EmpIcon_TERAWUT from "../../../../assets/images/dashbaord/emp/TERAWUT.png";
import EmpIcon_ALL_01 from "../../../../assets/images/dashbaord/emp/all_01.png";

 
import {
  DATA_MASTER_DATA_TYPE,
  INDUSTRY,
  INDUSTRY_TYPE,
  REGION_GROUP,
  SUCCESS_CODE,
  WORK_PERIOD,
  COMPANY_TYPE,
} from "../../../../lib/const";
import useEState from "../../../../lib/hooks/useEState";
import useLineOfWork from "../../../../lib/hooks/useLineOfWork";
import useMasterData from "../../../../lib/hooks/useMasterData";
import useCountry from "../../../../lib/hooks/useCountry";
import useStaffName from "../../../../lib/hooks/useStaffName";
import moment from "moment";

import {
  getDashboardMarketingActionPlan,
  getDashboardCrmPlan

} from "../../../../services/dashboardService";
import { SearchMarketingActionPlanContext } from "../searchContext";
import "../style.css";
import TextArea from "antd/es/input/TextArea";

let emp_dynamic;

const { Option } = Select;
const years = moment().add(1, "years").format("YYYY");
const yearArray = [
  parseInt(years),
  parseInt(years - 1),
  parseInt(years - 2),
  parseInt(years - 3),
  parseInt(years - 4),
];

const Content = ({ roleUser }) => {
  const navigate = useNavigate();
  const {
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    g_year,
    setSearch,
  } = useContext(SearchMarketingActionPlanContext);
  const [lineOfWork] = useLineOfWork();
  const [estate] = useEState();
  const [staffName] = useStaffName();
  const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
  const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
  const [industryType] = useMasterData(DATA_MASTER_DATA_TYPE, INDUSTRY_TYPE);
  const [industries] = useMasterData("", INDUSTRY);
  const [companyType] = useMasterData(DATA_MASTER_DATA_TYPE, COMPANY_TYPE);
  let [no, setNo] = useState(0);
  // const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [dataSourceCrm, setDataSourceCrm] = useState([]);
  const [dataSourceVocWant, setDataSourceVocWant] = useState([]);
  const [dataSourceVocExpected, setDataSourceVocExpected] = useState([]);

  const [isShow, setIsShow] = useState([]);



  //console.log(lineOfWork);
  //console.log(staffName);

   

  const fetchMargektingActionPlan = useCallback(
    async (p_year) => {
      console.log("year parameter=>");
      console.log(p_year);
      if (!p_year || p_year == "") return;
      p_year = parseInt(p_year, 10) + 543;
      const res = await getDashboardMarketingActionPlan(p_year);
      console.log("return from webservice => ");
      console.log(res.data);


      if (res?.data?.code === SUCCESS_CODE) {
        var { objectValue, pageValue } = res.data;
        console.log("SEARCH SUCCESS ");
        setDataSource(objectValue.dashboardMarketingActionPlanDetailsList);
        //isShow=true;
        setIsShow(p_year);
      }

    },
    [setDataSource, setIsShow]
  );

  useEffect(() => {
    if (!isShow) return;
    fetchMargektingActionPlan(g_year);


  }, [fetchMargektingActionPlan, g_year]);

  ///---------CRM--------------------///
  const fetchCrmPlan = useCallback(
    async (p_year) => {
      console.log("year parameter=>");
      console.log(p_year);
      if (!p_year || p_year == "") return;
      p_year = (parseInt(p_year, 10) + 543) + "";

      const res = await getDashboardCrmPlan(p_year);
      console.log("return from CRM webservice => ");
      console.log(res.data);


      if (res?.data?.code === SUCCESS_CODE) {
        var { objectValue, pageValue } = res.data;
        console.log("SEARCH CRM SUCCESS ");
        setDataSourceCrm(objectValue.dashboardCrmPlanDetailsList);
        setDataSourceVocWant(objectValue.dashboardVocWantDetailsList);
        setDataSourceVocExpected(objectValue.dashboardVocExpectedDetailsList);
        //isShow=true;
      }

    },
    [setDataSourceCrm, setDataSourceVocWant, setDataSourceVocExpected, setIsShow]
  );

  useEffect(() => {
    if (!isShow) return;
    fetchCrmPlan(g_year);


  }, [fetchCrmPlan, g_year]);


  const onYearChange = (value) => {
    console.log("onYearChange=" + value);
    fetchMargektingActionPlan(value);
    fetchCrmPlan(value);

  };
 



  return (
    <>
      <div>
        <Row>

          <Col className="gutter-row" span={4}>
            <Select
              onChange={onYearChange}
              id={"CBO_YEAR"}
              style={{
                width: "100%",
              }}
              placeholder="ปีงบประมาณ"
              mode={"single"}
              maxTagCount={"responsive"}
            >
              {yearArray.map((item) => (
                <Option value={parseInt(item)}>{parseInt(item) + 543}</Option>
              ))}

            </Select>
          </Col>
        </Row>
      </div>
      {isShow && (
        <div id={"MARKEING_PLAN"} className="gutter-box-mkp" style={{ marginTop: 20 }}>
          <Row>
            <Col span={4}></Col><Col span={16}><br /><div className="text-white-head-center">Marketing Action Plan ผลการดำเนินงานตามแผนปฏิบัติการด้านลูกค้าและตลาด ปีงบประมาณ {isShow} </div><br /><br /></Col><Col span={4}><img src={Logo} height={50} alt="I-EA-T LOGO" /></Col>
          </Row>
          <div className="div_1st">

            {dataSource.map(function (objItem, i) {
              return (
                <div className="div_2nd">
                  <div className="div_top">
                    <div className="div_img_emp">
                      {(() => {
                        // { emp_dynamic = null }
                        // { emp_dynamic = objItem.projectName.includes("ร่วมทุน") ? EmpIcon_SUMET : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("พัฒนาธุรกิจ") ? EmpIcon_SUMET : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("ฐานข้อมูล") ? EmpIcon_SUMET : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("ภาพลักษณ์") ? EmpIcon_SUMET : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("เช่า") ? EmpIcon_LINEE : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("Driven") ? EmpIcon_LINEE : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("ประเมินผล") ? EmpIcon_LINEE : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("System") ? EmpIcon_LINEE : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("แข่งขัน") ? EmpIcon_LINEE : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("เครื่องมือ") ? EmpIcon_LINEE : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("พฤติกรรม") ? EmpIcon_LINEE : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("Visit") ? EmpIcon_ALL_01 : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("พันธมิตร") ? EmpIcon_NIPA : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("e-PP") ? EmpIcon_BUPA : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("เชิงนิเวศ") ? EmpIcon_BUPA : (emp_dynamic === null ? null : emp_dynamic) }
                        // { emp_dynamic = objItem.projectName.includes("Smart") ? EmpIcon_KUNPONG : (emp_dynamic === null ? null : emp_dynamic) }


                        // var v_width = (emp_dynamic == EmpIcon_ALL_01) ? 130 : 80
                        // return <img src={(emp_dynamic === null) ? EmpIcon_2 : emp_dynamic} width={v_width} alt="Emp Picture" />

                       // return (objItem?.projectImagePath=="") ?<img src={EmpIcon_2} width={v_width} alt="Emp Picture" /> 
                       var v_width = (objItem?.projectImageName.includes("all") || objItem?.projectImageName.includes("landscape")  ) ? 130 : 80
                       return <img src={(objItem?.projectImagePath==""||objItem?.projectImagePath=="null") ? EmpIcon_2 :`${"data:image/jpeg;base64," + objItem.projectImageByte}`} width={v_width} alt="Emp Picture" />

                        

                      })()}
                    </div>
                    <div className="div_result_right">
                      <div className="bar_target">เป้าหมาย 100%</div>
                      <div className="bar_result" style={{ width: objItem.projectProgress + '%' }}></div>
                      <div className="text_result">
                        <b>ผลการดำเนินการสะสม {objItem.projectProgress} %</b>
                      </div>
                    </div>

                  </div>

                  <div className="bar_empty_thin"> </div>
                  <div className="text_result">
                    {objItem.projectName}
                  </div>
                </div>
              )

            })}

          </div>
          <Row>
            <Col span={4}></Col><Col span={16}><br /><div className="text-white-head-center">CRM Plan ผลการดำเนินการเยี่ยมลูกค้าเปรียบเทียบเป้าหมาย ปีงบประมาณ {isShow}</div><br /><br /></Col><Col span={4}></Col>
          </Row>
          <div className="div_1st">

            {dataSourceCrm.map(function (objItem, i) {

              return (

                <div className="div_2nd">
                  <div>
                  {(() => {
                        { emp_dynamic = null }
                        { emp_dynamic = objItem.workLineName.includes("สายงานปฏิบัติการ 1") ? EmpIcon_PATEEP : (emp_dynamic === null ? null : emp_dynamic) }
                        { emp_dynamic = objItem.workLineName.includes("สายงานปฏิบัติการ 2") ? EmpIcon_TERAWUT : (emp_dynamic === null ? null : emp_dynamic) }
                        { emp_dynamic = objItem.workLineName.includes("สายงานปฏิบัติการ 3") ? EmpIcon_KUNPONG : (emp_dynamic === null ? null : emp_dynamic) }
                        

                        var v_width = (emp_dynamic == EmpIcon_ALL_01) ? 130 : 80
                        return <img src={(emp_dynamic === null) ? EmpIcon_2 : emp_dynamic} width={v_width} alt="Emp Picture" />
 
                        

                      })()}
                    <div className="div_result_right">
                      <div className="text_result">
                        <b> {objItem.workLineName}</b><br />
                      </div>
                      <div className="bar_target">เป้าหมาย 100%</div>
                      <div className="bar_result" style={{ width: objItem.workLinePercentProgress + '%' }}></div>
                      <div className="text_result">
                        <b>ผลการดำเนินการสะสม  {objItem.workLinePercentProgress} %</b><br />
                        <b>จำนวน {objItem.workLineVisitFactory} โรงงาน</b>
                      </div>
                    </div>

                  </div>

                  <div className="bar_empty"> </div>
                  <div className="text_result">
                    {objItem.projectName}
                  </div>
                </div>
              )

            })}

          </div>
          <Row>
            <Col span={4}></Col><Col span={16}><br /><div className="text-white-head-center">Voice of Customer (VOC) ประเด็นความต้องการและความคาดหวัง
              จากเสียงของลูกค้าสะสม ปีงบประมาณ {isShow}</div><br /><br /></Col><Col span={4}></Col>
          </Row>
          <Row className="div_white">
            <Col span={12} >
              <div className="div_title_violet">Need</div><br />

              {(() => {

                dataSourceVocWant.sort(function (a, b) { return b.count - a.count; })

              })()}
              {

                dataSourceVocWant.map(function (objItem, i) {

                  return (

                    <div className="div_white" >
                      <div className="text_result">
                        <b> {objItem.text}[{objItem.count}]</b>
                      </div>
                      <div className="bar_empty_thin"> </div>
                      <div className="bar_result" style={{ width: objItem.count / 5 + '%' }}></div>
                      <div className="bar_empty"> </div>
                    </div>
                  )

                })}
            </Col>
            <Col span={12}>
              <div className="div_title_violet">Expected</div><br />
              {(() => {

                dataSourceVocExpected.sort(function (a, b) { return b.count - a.count; })

              })()}
              {dataSourceVocExpected.map(function (objItem, i) {

                return (

                  <div className="div_white" >
                    <div className="text_result">
                      <b> {objItem.text}[{objItem.count}]</b>
                    </div>
                    <div className="bar_empty"> </div>
                    <div className="bar_result" style={{ width: objItem.count / 5 + '%' }}></div>
                    <div className="bar_empty"> </div>
                  </div>
                )

              })}
            </Col>
          </Row>
        </div>
      )}
    </>


  );
};



export default Content;
